<script lang="ts">
    import Input from './Input.svelte';
    import Modal from './Modal.svelte';
    import * as t from '../translations/Common.ts';
    import CheckIcon from '../icons/CheckIcon.svelte';
    import { postEmailVerification, postEmailVerificationProof, getIdentities, type UserIdentity } from "../api/users";
    import type { ValidationMessage } from '../api/common';

    const ERROR = {
        InvalidCode: 'Invalid Code',
    };
    
    export let isAwaitingVerification = false;
    export let emailAddress: string = '';
    export let headerText = t.Email_Verification_Label();

    export let onUserVerified: (user: UserIdentity) => void = () => {};
    export let onNotFound = () => {};
    export let onFailure = () => {};

    let verificationId = '';
    let verificationCode = '';
    let errorMessages: ValidationMessage[] = [];
    let isUserVerified = false;
    
    const onOpen = async () => {
        try {
            verificationId = '';
            verificationCode = '';
            errorMessages = [];
            isUserVerified = false;
            const result = await postEmailVerification(emailAddress);
            verificationId = result.verificationId;
        }
        catch (error: any){
            if (error.statusCode === 429) {
                verificationId = error.data.verificationId;
            }
        }
    };
    
    async function checkVerificationCode(verificationCode: string) {
        if (verificationId && verificationCode.length === 4) {
            try {
                const result = await postEmailVerificationProof(verificationId, verificationCode);
                const users = await getIdentities(emailAddress, result.proof);
                if (users && users.length > 0) {
                    errorMessages = [];
                    isUserVerified = true;
                    onUserVerified(users[0]);
                    
                    setTimeout(() => {
                        isAwaitingVerification = false;
                    }, 2500);
                } else {
                    onNotFound();
                }
            }
            catch (error: any) {
                if (error.statusCode === 404) {
                    buildErrorMessages([ERROR.InvalidCode])
                    onNotFound();
                } else {
                    onFailure();
                }
            }
        }
    }

    function buildErrorMessages(messages: string[]) {
        let validationErrorMappings = [
            {
                originalError: ERROR.InvalidCode,
                formattedError: {
                    message: t.Email_Verification_Code_Invalid(),
                    propertyName: 'verificationCode'
                }
            }
        ];

        let newErrorMessages: ValidationMessage[] = [];

        for (let i = 0; i < messages.length; i++) {
            const message = messages[i];
            const matchingMappings = validationErrorMappings.filter((item) =>
                message.includes(item.originalError)
            );
            if (matchingMappings.length > 0) {
                newErrorMessages.push(...matchingMappings.map((item) => item.formattedError));
            } else {
                newErrorMessages.push({ message: message, propertyName: '' });
            }
        }
        errorMessages = newErrorMessages;
    }
    
    $ : checkVerificationCode(verificationCode);
</script>

<Modal bind:isOpen={isAwaitingVerification} 
       bind:headerText={headerText}
       {onOpen}>
    {@html t.Email_Verification_Message(emailAddress)}
    
    <div class="flex flex-row gap-2">
        <div>
            <Input fieldsetClass="w-[200px]"
                   class="mt-2"
                   placeholder={t.Enter_Email_Verification_Placeholder()}
                   bind:value={verificationCode} maxlength="4"
                   errors={errorMessages
					.filter((item) => item.propertyName === 'verificationCode')
					.map((item) => `${item.message}`)}>
            </Input>
        </div>
        <div class="my-auto">
            {#if isUserVerified}
                <CheckIcon width="20" height="20" color="#22a06b"></CheckIcon>
            {/if}
        </div>
    </div>
    
    <br/>
    {@html t.Email_Verification_Junk_Message()}
</Modal>
